import { eapPurchasesForFeedbackQuery } from "@/api/sales";
import { queryClient } from "@/api/utils";
import { toast } from "@givenwell/components";
import { createFileRoute, lazyRouteComponent, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/eap-review/$purchaseId")({
  component: lazyRouteComponent(() => import("./+ReviewDetail")),
  beforeLoad: async ({ params, preload }) => {
    if (preload) return;
    const data = await queryClient.ensureQueryData(eapPurchasesForFeedbackQuery(params.supplierId));
    if (!data.purchases.some(p => p.id === params.purchaseId)) {
      setTimeout(() => toast.success("This session has already been completed."), 500);
      throw redirect({
        to: "/supplier/$supplierId/eap-review",
        params: { supplierId: params.supplierId },
        replace: true,
      });
    }
  },
});
